import { Alert } from '@/components/ui/catalyst/alert';
import { Button } from '@/components/ui/catalyst/button';
import { Heading } from '@/components/ui/catalyst/heading';
import { Text } from '@/components/ui/catalyst/text';
import { AgentChatWorkspace } from '@/services/types/agent-chat-workspace-types';

interface DeleteWorkspaceConfirmationProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  workspaceId: string | null;
  workspaces: AgentChatWorkspace[];
}

export const DeleteWorkspaceConfirmation = ({
  isOpen,
  onCancel,
  onConfirm,
  workspaceId,
  workspaces,
}: DeleteWorkspaceConfirmationProps) => {
  // Find the workspace title to display in the confirmation
  const workspaceToDelete = workspaces.find(
    (workspace) => workspace.id === workspaceId,
  );

  if (!isOpen || !workspaceId) return null;

  return (
    <Alert open={isOpen} onClose={onCancel}>
      <div className="p-4">
        <Heading level={3} className="mb-2">
          Delete Workspace
        </Heading>

        <Text className="mb-4">
          Are you sure you want to delete the workspace
          <span className="font-semibold">
            {workspaceToDelete ? ` "${workspaceToDelete.name}"` : ''}
          </span>
          ? This action cannot be undone.
        </Text>

        <div className="flex justify-end gap-2 mt-6">
          <Button onClick={onCancel} className="bg-gray-200 hover:bg-gray-300">
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            Delete
          </Button>
        </div>
      </div>
    </Alert>
  );
};
